"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point2dSubcategory = void 0;
const get_range_from_indexed_connector_1 = require("../../indexed-point-2d/get-range-from-indexed-connector");
const t_point2d_size_normalizer_trait_1 = require("../../traits/t-point2d-size-normalizer-trait");
/**
 * @public
 * Membership hooks for 2d points, normalizes point display size.
 */
class Point2dSubcategory {
    constructor(pixelSizeRange) {
        this.normalization = new t_point2d_size_normalizer_trait_1.Point2dSizeNormalizer(pixelSizeRange);
    }
    onEntityAdded(entity) {
        const range = (0, get_range_from_indexed_connector_1.getRangeFromIndexedConnector)(entity.data);
        if (range != null) {
            this.normalization.extendDataRange(range.getMin(), range.getMax());
        }
    }
    onEntityRemoved() {
        // no way to lower range from here
    }
}
exports.Point2dSubcategory = Point2dSubcategory;
//# sourceMappingURL=point2d-subcategory.js.map